module.exports = __webpack_public_path__ + "static/img/about2.b001fe2c.jpeg";